import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { EVENT_TYPES } from './constants';

export const formatValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  return <div className="min-w-max">{Number.isNaN(date.getTime()) ? value : date.toLocaleString('ru-RU')}</div>;
};

export const formatBool = (value) => {
  if (value === null || value === undefined) return '-';
  return <span className={value ? 'text-green-600' : 'text-gray-500'}>{value ? 'Да' : 'Нет'}</span>;
};

export const formatAllowed = (value) => {
  if (value === null || value === undefined) return '-';

  return (
    <div className="min-w-max flex items-center gap-x-1">
      {value ? <CheckCircleIcon className="text-green-500" fontSize="small" /> : <CancelIcon className="text-red-500" fontSize="small" />}
      <span>{value ? 'Да' : 'Нет'}</span>
    </div>
  );
};

export const formatNumber = (value) => {
  if (value === null || value === undefined) return '-';
  return Number(value).toLocaleString('ru-RU');
};

/** Бэкенд отдаёт размеры в байтах */
export const formatBytes = (value) => {
  if (value === null || value === undefined) return '-';
  const bytes = Number(value);
  if (Number.isNaN(bytes)) return formatValue(value);
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toLocaleString('ru-RU', { maximumFractionDigits: 1 })} КБ`;
  return `${(bytes / (1024 * 1024)).toLocaleString('ru-RU', { maximumFractionDigits: 2 })} МБ`;
};

export const formatEventType = (value) => {
  const type = EVENT_TYPES[value];
  if (!type) return formatValue(value);

  return (
    <div className="min-w-max flex items-center gap-x-2">
      {type.icon}
      <div>{type.label}</div>
    </div>
  );
};

export const formatStatusCode = (value) => {
  if (!value) return '-';
  const code = Number(value);
  const className = code >= 500 ? 'text-red-500' : code >= 400 ? 'text-orange-500' : 'text-green-600';
  return <span className={className}>{value}</span>;
};

export const formatChannel = (value) => {
  if (value === 'test') return 'Тестовый';
  if (value === 'stable') return 'Стабильный';
  return formatValue(value);
};
